import React from 'react'
import Header from '../../components/Header/Header'
import Footer from '../../components/Footer/Footer'
const familyplanning = () => {
    return (
        <div>
            <Header />

            <section class="banner bannerblue">
                <div class="banner-blk">
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-md-7">
                                <div class="content-blk">
                                    <div class="hero-eyebrow">
                                        <span claclassnamess="hero-dot"></span>
                                        <span class="overline"> Family Planning · Stage 2 Compatibility · Reproductive Safety</span>
                                    </div>
                                    <h1 class="disp-xl">Know if you can have
                                        healthy children together<br /><em class="sage">before you try.</em></h1>
                                    <p class="body-lg">The same DNA sample that finds your compatible partner also tells you whether having children together carries elevated genetic risk. One kit. Both answers.</p>
                                    <div class="hero-btns">
                                        <button class="btn btn-sage">Family Planning Assessment<span class="arr">→</span></button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-5">
                                <div class="hero-img-stack">
                                    <img alt="" src="/images/familyplanning-banner.jpg" />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <div className="sec sec-white">
                <div className="sec-label">
                    <span
                        className="overline"
                        style={{ color: "var(--sage)" }}
                    >
                        Stage 2: Family Planning Compatibility
                    </span>
                </div>

                <h2 className="disp-md">
                    The conversation every couple should have
                    <br />
                    before they start trying — not after.
                </h2>

                <div className="row split align-items-center" style={{ marginTop: "32px" }} >
                    <div className="col-md-6">
                        <div className="split-img">
                            <img src="https://images.unsplash.com/photo-1492725764893-90b379c2b6e7?w=600&q=80"
                                alt="Family with young child"
                                loading="lazy" />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <h3>What the family planning stage covers</h3>

                        <p>
                            Stage 2 compatibility uses the same DNA sample from Stage 1 to compute a
                            completely different set of scores — focused entirely on reproductive
                            safety, genetic disease risk, immune tolerance of pregnancy, and embryo
                            viability.
                        </p>

                        <div
                            className="grid g2"
                            style={{ gap: "12px", marginTop: "18px" }}
                        >
                            <div className="card" style={{ padding: "16px" }}>
                                <div style={{ fontSize: "20px", marginBottom: "6px" }}>🧬</div>
                                <div
                                    style={{
                                        fontSize: "13px",
                                        fontWeight: 600,
                                        marginBottom: "4px",
                                    }}
                                >
                                    Carrier Screening
                                </div>
                                <div style={{ fontSize: "13px", color: "var(--text-sec)" }}>
                                    300+ heritable conditions. Carrier status overlap computed for both
                                    partners. Risk flagged before conception.
                                </div>
                            </div>

                            <div className="card" style={{ padding: "16px" }}>
                                <div style={{ fontSize: "20px", marginBottom: "6px" }}>🛡️</div>
                                <div
                                    style={{
                                        fontSize: "13px",
                                        fontWeight: 600,
                                        marginBottom: "4px",
                                    }}
                                >
                                    HLA/KIR Immune Match
                                </div>
                                <div style={{ fontSize: "13px", color: "var(--text-sec)" }}>
                                    Immunogenetic compatibility score predicts implantation success,
                                    miscarriage risk, preeclampsia susceptibility.
                                </div>
                            </div>

                            <div className="card" style={{ padding: "16px" }}>
                                <div style={{ fontSize: "20px", marginBottom: "6px" }}>🥚</div>
                                <div style={{
                                    fontSize: "13px",
                                    fontWeight: 600,
                                    marginBottom: "4px",
                                }} >
                                    Embryo Viability Modelling
                                </div>
                                <div style={{ fontSize: "13px", color: "var(--text-sec)" }}>
                                    Monte Carlo inheritance simulation + polygenic offspring scoring +
                                    rare-variant interaction analysis.
                                </div>
                            </div>

                            <div className="card" style={{ padding: "16px" }}>
                                <div style={{ fontSize: "20px", marginBottom: "6px" }}>
                                    👩‍⚕️
                                </div>
                                <div
                                    style={{
                                        fontSize: "13px",
                                        fontWeight: 600,
                                        marginBottom: "4px",
                                    }}
                                >
                                    Genetic Counsellor Review
                                </div>
                                <div style={{ fontSize: "13px", color: "var(--text-sec)" }}>
                                    All high-risk results reviewed by a licensed genetic counsellor
                                    before being released to users.
                                </div>
                            </div>
                        </div>

                        <div
                            style={{
                                marginTop: "18px",
                                padding: "14px",
                                background: "#EEFDF4",
                                borderRadius: "var(--r8)",
                                border: "1px solid #A7F0BA",
                            }}
                        >
                            <div
                                style={{
                                    fontFamily: "var(--sans2)",
                                    fontSize: "10px",
                                    color: "#2A5940",
                                    fontWeight: 700,
                                    letterSpacing: ".08em",
                                    textTransform: "uppercase",
                                    marginBottom: "5px",
                                }}
                            >
                                IMPORTANT CLINICAL NOTE
                            </div>

                            <div style={{ fontSize: "13px", color: "var(--text-sec)" }}>
                                FutureSoulmates reproductive scores are predictive risk indicators,
                                not clinical diagnoses. A genetic counsellor reviews all elevated-risk
                                results before disclosure. No result should be interpreted as a
                                diagnosis or a recommendation to avoid having children. All clinical
                                decisions remain with the couple and their physician.
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="sec sec-blush">
                <div class="sec-label"><span class="overline" style={{ color: "var(--sage);" }}>Connection to Surrogacy4All</span></div>
                <h2 class="disp-md">The same platform powers<br />our surrogacy network.</h2>
                <p class="sec-sub">For intended parents using Surrogacy4All, FutureSoulmates' reproductive compatibility engine powers surrogate-intended parent immunogenetic matching — including HLA/KIR scoring to optimise implantation outcomes and gestational health monitoring via HelixFoundry.</p>
                <div class="grid g3" style={{ marginTop: "32px;" }}>
                    <div class="card"><span class="card-tag tag-lav">Surrogacy4All</span><h3>Surrogate Selection</h3><p>HLA/KIR immune matching between surrogate and intended parents. Optimises implantation probability and minimises preeclampsia risk before transfer.</p></div>
                    <div class="card"><span class="card-tag tag-lav">Donor Matching</span><h3>Egg Donor Compatibility</h3><p>Carrier status overlap between donor and intended father. HLA matching for optimal embryo outcomes. Available through EggDonors4All and IndianEggDonors.</p></div>
                    <div class="card"><span class="card-tag tag-lav">Clinical Monitoring</span><h3>HelixFoundry Integration</h3><p>Surrogates receive continuous preeclampsia monitoring via HelixFoundry's wearable biometric platform — the only such system in the world. Patent Claim C filed.</p></div>
                </div>
            </div>



            <div><section class="trusted-story">
                <div class="container p-0">
                    <div class="cta-sec cta-coral">
                        <h2 class="disp-md">Build your family on a foundation of science.</h2>
                        <p>Family Planning compatibility is included in every FutureSoulmates membership. One kit. Both stages.</p>
                        <div class="cta-btns">
                            <button class="btn btn-white">Join Waitlist <span class="arr">→</span></button>
                            <button class="btn investerbtn">Enterprise API</button>
                        </div></div></div></section></div>

            <Footer />
        </div>
    )
}

export default familyplanning
